import React, { useEffect, useRef, useState } from "react";
import "./textbox2.css";
import { useLocation } from "react-router-dom";

const Textbox2 = () => {
  const location = useLocation();
  const { pathname } = location;
  const isHomePage = pathname === '/';


  const [isVisible, setIsVisible] = useState(false);
  const headerRef = useRef(null);
  const contactRef = useRef(null);
  const isComponentMounted = useRef(true); // Cleanup flag

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    }, {});

    observer.observe(headerRef.current);
    observer.observe(contactRef.current);

    return () => {
      isComponentMounted.current = false; // Set the flag to false when unmounting
      observer.disconnect(); // Disconnect the observer to prevent errors
    };
  }, []);

  useEffect(() => {
    // Use another useEffect to handle state updates after component unmounts
    return () => {
      isComponentMounted.current = false; // Set the flag to false when unmounting
    };
  }, []);

  const handleGetInTouchClick = (event) => {
    event.preventDefault();
    window.location.href = "mailto:hpatadi07@gmail.com";
  };

  return (
    <>
    <div className={`textbox-container ${ isHomePage ? '' : 'center' }`}>
      <h1
        className={`footer-text ${isVisible ? "animate-text" : ""}`}
        ref={headerRef}
      >
        Let's work together.
      </h1>
      <h1
        className={`contact ${isVisible ? "animate-text" : ""}`}
        ref={contactRef}
      >
        <a href="#" onClick={handleGetInTouchClick}>
          Get in touch.
        </a>
      </h1>
      </div>
    </>
  );
};

export default Textbox2;
